// extracted by mini-css-extract-plugin
module.exports = {"hero__heading":"_a1","heroBG":"_a2","hero":"_a3","hero__box":"_a4","hero__subheading":"_a5","hero__pageLink":"_a6"};